import { createCustomEnum } from "./enums/createcustomEnum";

const TypeOfLocationValues = createCustomEnum({
	Home: {
		name: "home",
		value: 0,
		displayName: "Home",
	},
	Office: {
		name: "office",
		value: 4,
		displayName: "Office",
	},
	StoreFront: {
		name: "store_front",
		value: 2,
		displayName: "Store Front",
	},
	Other: {
		name: "other",
		value: 3,
		displayName: "Other",
	},
});

export default TypeOfLocationValues;
